import { createContext, useContext } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { ThemeDto } from '../api/themes.api';

interface ThemeEditorContextType {
  themeOverrides: Record<string, ThemeDto>;
  setThemeOverrides: Dispatch<SetStateAction<Record<string, ThemeDto>>>;
}

export const ThemeEditorContext = createContext<ThemeEditorContextType | undefined>(undefined);

export const useThemeEditorContext = () => {
  const context = useContext(ThemeEditorContext);
  if (!context) {
    throw new Error('useThemeEditorContext must be used within a ThemeEditorProvider');
  }
  return context;
};
